<template>
  <div class="apartments">
    <div class="categoryTitleWrapper">
      <div class="gardeshgariTitle">ذخیره</div>
    </div>
    <div
      style="margin-top: 30px"
      v-if="data_list.length == 0 && isLoading"
      class="apartmentsListContainer"
    >
      <Skeletor
        v-for="(v, i) in 12"
        :key="i"
        class="ChildShowTabToUserCustomer sliderBottm"
        height="308"
        style="
          background: rgb(163, 219, 213);
          margin-bottom: 2rem;
          border-radius: 10px;
        "
      />
    </div>

    <div
      v-show="data_list.length > 0 && !isLoading"
      class="propertyListsContainer"
    >
      <div
        class="propertyThumb"
        v-for="(v, i) in data_list"
        :key="i"
        @click="showPost(v, i)"
      >
        <div class="propertyPic" @click.stop>
          <div class="deleteIcon" @click="save_favorit(v.id)">
            <span class="fa fa-bookmark"></span>
          </div>
          <img :src="v.avatar" :alt="v.content" @error="handleImageError" />
          <!-- <Swiper
            :slides-per-view="1"
            :navigation="true"
            :modules="modules"
            :pagination="{
              dynamicBullets: true,
            }"
          >
            <SwiperSlide v-for="(v, i) in v.photo_galleries" :key="i">
              <img :src="v.url" :alt="v.content" />
            </SwiperSlide>
          </Swiper> -->
        </div>
        <div class="propertyContent">
          <div class="contanteHeader">
            <div class="propertyCategory">
              {{ v.main_category }}
              <span v-if="v.main_category_en == 'request'">{{
                v.request_type
              }}</span>
              - {{ v.category }}
            </div>
            <div class="propertyUpload">
              <div class="propertyUploadIcon">
                <VsxIcon
                  iconName="Calendar"
                  :size="14"
                  color="#0096c7"
                  type="linear"
                />
              </div>
              <div class="propertyUploadTitle">{{ v.created_fa }}</div>
            </div>
          </div>
          <div class="contentMain">
            <div class="propertyTitle">
              {{
                v.content.length > 38
                  ? v.content.slice(0, 38) + "..."
                  : v.content
              }}
            </div>
            <div class="propertyLocation">
              <div class="locationIcon">
                <i class="fa-solid fa-location-dot"></i>
              </div>
              <div class="locationTitle">
                {{ v.address }}
                <!-- {{
                  v.address.length > 38
                    ? v.address.slice(0, 38) + "..."
                    : v.address
                }} -->
              </div>
            </div>
            <div class="contentFeaturesWrapper">
              <!-- <div
                  v-if="v.feature && v.feature.includes('request')"
                  class="featuresThumb request"
                >
                  <i class="fas fa-user"></i>
                  <span>متقاضی</span>
                </div> -->
              <div
                v-if="v.feature && v.feature.includes('fast')"
                class="featuresThumb fast"
              >
                <i class="fa-solid fa-bolt"></i>
                <span>فوری</span>
              </div>
              <div
                v-if="v.feature && v.feature.includes('exchangeable')"
                class="featuresThumb exchange"
              >
                <i class="fa-solid fa-rotate"></i>
                <span>قابل معاوضه</span>
              </div>
              <div
                v-if="
                  v.feature &&
                  (v.feature.includes('single') ||
                    v.feature.includes('student'))
                "
                class="featuresThumb single"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                  />
                  <path
                    d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                  />
                  <path
                    d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                  />
                </svg>
                <span>دانشجو/مجرد</span>
              </div>
            </div>
            <div class="contentPriceWrapper">
              <div
                class="priceWrapper"
                v-if="
                  v.main_category_en != 'rent' &&
                  !(
                    v.main_category_en == 'request' &&
                    v.request_type_en == 'rent'
                  )
                "
              >
                <div class="pricecTitle" v-if="v.main_category_en == 'trade'">
                  قیمت فروش:
                </div>
                <div class="pricecTitle" v-if="v.main_category_en == 'request'">
                  قیمت خرید:
                </div>
                <div v-if="v.main_category_en != 'request'" class="priceValue">
                  {{ v.total_price }}
                </div>
                <div v-if="v.main_category_en == 'request'" class="priceValue">
                  {{ v.total_price }} تا {{ v.total_price_max }}
                </div>
              </div>
              <div
                class="priceWrapper"
                v-if="
                  v.main_category_en == 'rent' ||
                  (v.main_category_en == 'request' &&
                    v.request_type_en == 'rent')
                "
              >
                <div class="pricecTitle">مبلغ رهن:</div>
                <div v-if="v.main_category_en != 'request'" class="priceValue">
                  {{ v.mortgage_price }}
                </div>
                <div v-if="v.main_category_en == 'request'" class="priceValue">
                  {{ v.mortgage_price }} تا {{ v.mortgage_price_max }}
                </div>
              </div>
              <div
                class="priceWrapper"
                v-if="
                  v.main_category_en == 'rent' ||
                  (v.main_category_en == 'request' &&
                    v.request_type_en == 'rent')
                "
              >
                <div class="pricecTitle">مبلغ اجاره:</div>
                <div v-if="v.main_category_en != 'request'" class="priceValue">
                  {{ v.rent_price }}
                </div>
                <div v-if="v.main_category_en == 'request'" class="priceValue">
                  {{ v.rent_price }} تا {{ v.rent_price_max }}
                </div>
              </div>
            </div>
            <!-- <div class="contentPriceWrapper">
              <div class="priceWrapper" v-if="v.main_category_en != 'rent'">
                <div class="pricecTitle">خرید:</div>
                <div class="priceValue">{{ v.total_price }}</div>
              </div>
              <div class="priceWrapper" v-if="v.main_category_en == 'rent'">
                <div class="pricecTitle">اجاره:</div>
                <div class="priceValue">{{ v.rent_price }}</div>
              </div>
              <div class="priceWrapper" v-if="v.main_category_en == 'rent'">
                <div class="pricecTitle">رهن:</div>
                <div class="priceValue">{{ v.mortgage_price }}</div>
              </div>
            </div> -->
            <div class="realStateInfoWrapper">
              <div v-if="v.user_role == 'builder' || v.user_role == 'customer'" class="realStateInfo">
                <div class="infoPic">
                  <img :src="v.user_avatar" alt="" />
                </div>
                <div class="infoTitle">
                  {{ v.nickname }}
                </div>
              </div>
              <div v-else class="realStateInfo">
                <div class="infoPic">
                  <img :src="v.branch_avatar" alt="" />
                </div>
                <div class="infoTitle">
                  {{ v.branch_title }}
                </div>
              </div>
              <div class="realStateBtn">
                <div class="followBtn">
                  <div class="btnTitle">جزئیات</div>
                  <div class="btnIcon">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="contentFooter">
            <div class="propertyOptions">
              <div class="optionThumb">
                <div class="optionIcon">
                  <i class="fa-solid fa-ruler-combined"></i>
                </div>
                <div class="optionTitle">{{ v.building_area }} متر</div>
              </div>
              <div class="optionThumb">
                <div class="optionIcon"><i class="fa-solid fa-bed"></i></div>
                <div class="optionTitle">{{ v.bedroom }} خوابه</div>
              </div>
              <div class="optionThumb">
                <div class="optionIcon">
                  <svg
                    fill="#000000"
                    height="800px"
                    width="800px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                  >
                    <g transform="translate(1 1)">
                      <g>
                        <g>
                          <path
                            d="M485.4-1H24.6c-5.12,0-8.533,3.413-8.533,8.533v494.933c0,5.12,3.413,8.533,8.533,8.533h51.2h153.6H383h102.4
				c5.12,0,8.533-3.413,8.533-8.533V7.533C493.933,2.413,490.52-1,485.4-1z M220.867,493.933H84.333V118.467h136.533V493.933z
M237.933,493.933V118.467h136.533v375.467H237.933z M476.867,493.933h-85.333v-384c0-5.12-3.413-8.533-8.533-8.533H229.4H75.8
				c-5.12,0-8.533,3.413-8.533,8.533v384H33.133V16.067h443.733V493.933z"
                          />
                          <path
                            d="M186.733,84.333h85.333c14.507,0,25.6-11.093,25.6-25.6s-11.093-25.6-25.6-25.6h-85.333c-14.507,0-25.6,11.093-25.6,25.6
				S172.227,84.333,186.733,84.333z M186.733,50.2h85.333c5.12,0,8.533,3.413,8.533,8.533s-3.413,8.533-8.533,8.533h-85.333
				c-5.12,0-8.533-3.413-8.533-8.533S181.613,50.2,186.733,50.2z"
                          />
                          <path
                            d="M423.107,286.573L434.2,275.48l11.093,11.093c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56
				c3.413-3.413,3.413-8.533,0-11.947l-17.067-17.067c-3.413-3.413-8.533-3.413-11.947,0l-17.067,17.067
				c-3.413,3.413-3.413,8.533,0,11.947C414.573,289.987,419.693,289.987,423.107,286.573z"
                          />
                          <path
                            d="M428.227,354.84c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56l17.067-17.067
				c3.413-3.413,3.413-8.533,0-11.947c-3.413-3.413-8.533-3.413-11.947,0L434.2,336.92l-11.093-11.093
				c-3.413-3.413-8.533-3.413-11.947,0c-3.413,3.413-3.413,8.533,0,11.947L428.227,354.84z"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="optionTitle">آسانسور</div>
              </div>
              <div class="optionThumb">
                <div class="optionIcon">
                  <svg
                    width="800px"
                    height="800px"
                    viewBox="0 0 60.601 60.601"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:cc="http://creativecommons.org/ns#"
                    xmlns:dc="http://purl.org/dc/elements/1.1/"
                    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                  >
                    <metadata>
                      <rdf:RDF>
                        <cc:Work rdf:about="">
                          <dc:format>image/svg+xml</dc:format>
                          <dc:type
                            rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                          />
                          <dc:title />
                          <dc:source
                            >http://www.mlit.go.jp/common/001245686.pdf</dc:source
                          >
                        </cc:Work>
                      </rdf:RDF>
                    </metadata>
                    <path
                      d="m7.7855 56.032c-1.7762 0-3.2162-1.44-3.2162-3.2162v-45.03c0-1.7762 1.44-3.2162 3.2162-3.2162h45.031c1.775 0 3.215 1.44 3.215 3.2162v45.03c0 1.7762-1.44 3.2162-3.215 3.2162h-45.031z"
                      style="fill: #ffffff; stroke-width: 0.60625; stroke: #000"
                    />
                    <path
                      d="m43.686 42.623c-1.4462 0-2.6175-1.1738-2.6175-2.6175 0-1.4475 1.1712-2.6188 2.6175-2.6188 1.4438 0 2.6175 1.1712 2.6175 2.6188 0 1.4438-1.1738 2.6175-2.6175 2.6175zm-19.098 0c-1.445 0-2.6175-1.1738-2.6175-2.6175 0-1.4475 1.1725-2.6188 2.6175-2.6188 1.4462 0 2.6175 1.1712 2.6175 2.6188 0 1.4438-1.1712 2.6175-2.6175 2.6175zm0.30375-13.666 0.07875-0.0088c3.03-0.315 6.1138-0.475 9.1662-0.475 3.0538 0 6.1388 0.16 9.17 0.47625l0.07875 0.0087 1.7988 6.26h-22.1l1.8075-6.2612zm21.878 6.2612-2.2-7.665c-3.4212-0.4025-6.9038-0.60875-10.432-0.60875-3.53 0-7.0112 0.20625-10.432 0.60875l-2.2012 7.665c-1.32 0-2.3838 1.07-2.3838 2.39v8.9088h2.3662l-0.0012 3.805c0.57875 0.20875 1.1888 0.325 1.8412 0.325 0.64125 0 1.27-0.11 1.84-0.315v-3.8162l17.94-0.0038v3.81c0.58 0.20875 1.1888 0.325 1.8412 0.325 0.64125 0 1.2688-0.11 1.84-0.315l0.0012-3.82h2.375v-8.9038c0-1.32-1.0725-2.39-2.3938-2.39"
                    />
                    <path
                      d="m16.538 19.054h1.4438c1.9262 0 3.4605-0.69225 3.4605-2.8882 0-2.1367-1.5344-2.8289-3.4605-2.8289h-1.4438zm-5.5965-9.688h6.6792c6.4087 0 9.4175 2.1667 9.4175 6.8897 0 4.2427-3.0987 6.7698-8.3342 6.7698h-2.166v7.3415h-5.5965v-21.001"
                    />
                  </svg>
                </div>
                <div class="optionTitle">پارکینگ</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div v-show="data_list.length > 0 && !isLoading">
      <div class="apartmentsListContainer">
        <div v-for="(v, i) in data_list" class="property-list" :key="i">
          <a>
            <article class="property">
              <div class="deleteIcon" @click="save_favorit(v.id)">
                <span class="fa fa-bookmark"></span>
              </div>

              <header @click="showPost(i)" class="property__ref-info">
                <div class="property__picture">
                  <img :src="v.avatar" :alt="v.content" />
                </div>

                <div class="ShowToUserButton-favorite">
                  <button class="button-favorite">
                    <img :src="v.branch_avatar" alt="" />
                  </button>

                  <div class="ShowToUserButton-favoriteText">
                    مشاور املاک
                    <span style="font-family: 'iranyekanB'">
                      {{ v.branch_title }}</span
                    >
                  </div>
                </div>
              </header>

              <section @click="showPost(i)" class="property__main-info">
                <h3 class="property__title">
                  {{
                    v.content.length > 38
                      ? v.content.slice(0, 38) + "..."
                      : v.content
                  }}
                </h3>
                <span class="property__location" v-if="v.address">
                  <VsxIcon
                    iconName="Location"
                    :size="28"
                    color="#0096c7 "
                    type="linear"
                  />
                  {{
                    v.address.length > 38
                      ? v.address.slice(0, 38) + "..."
                      : v.address
                  }}
                </span>
                <span
                  class="property__location property__Date"
                  v-if="v.address"
                >
                  <VsxIcon
                    iconName="Calendar"
                    :size="28"
                    color="#0096c7 "
                    type="linear"
                  />
                  12/12/1403
                </span>
              </section>

              <div class="post-price-show">
                <div
                  v-if="v.main_category_en == 'rent'"
                  class="ShowPriceToUsView"
                >
                  <div class="LeftIconShowPriceToUsView">رهن</div>

                  <p>{{ v.mortgage_price }}</p>
                </div>

                <div class="ShowPriceToUsView">
                  <div class="LeftIconShowPriceToUsView">
                    <span v-if="v.main_category_en != 'rent'">قیمت</span>
                    <span v-if="v.main_category_en == 'rent'">اجاره</span>
                  </div>

                  <p v-if="v.main_category_en == 'rent'">{{ v.rent_price }}</p>

                  <p v-if="v.main_category_en != 'rent'">{{ v.total_price }}</p>
                </div>
              </div>
              <footer class="property__amenities">
                <div class="property__amenity">
                  <div class="property__amenity-icon">
                    <svg
                      fill="#000000"
                      height="25px"
                      width="25px"
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 512 512"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M478.609,225.48v-86.35c0-46.03-37.448-83.478-83.478-83.478H116.87c-46.03,0-83.478,37.448-83.478,83.478v86.35
                          C13.959,232.372,0,250.93,0,272.696c0,12.589,0,89.885,0,100.174c0,9.22,7.475,16.696,16.696,16.696h16.696v50.087
                          c0,9.22,7.475,16.696,16.696,16.696h66.783c9.22,0,16.696-7.475,16.696-16.696v-50.087h244.87v50.087
                          c0,9.22,7.475,16.696,16.696,16.696h66.783c9.22,0,16.696-7.475,16.696-16.696v-50.087h16.696c9.22,0,16.696-7.475,16.696-16.696
                          c0-9.493,0-86.461,0-100.174C512,250.93,498.041,232.372,478.609,225.48z M66.783,139.13c0-27.618,22.469-50.087,50.087-50.087
                          H395.13c27.618,0,50.087,22.469,50.087,50.087v83.478h-33.391v-16.696c0-27.618-22.469-50.087-50.087-50.087h-72.348
                          c-12.819,0-24.523,4.846-33.391,12.794c-8.869-7.948-20.572-12.794-33.391-12.794h-72.348c-27.618,0-50.087,22.469-50.087,50.087
                          v16.696H66.783V139.13z M378.435,205.913v16.696H272.696v-16.696c0-9.206,7.49-16.696,16.696-16.696h72.348
                          C370.945,189.217,378.435,196.707,378.435,205.913z M239.304,205.913v16.696H133.565v-16.696c0-9.206,7.49-16.696,16.696-16.696
                          h72.348C231.815,189.217,239.304,196.707,239.304,205.913z M100.174,422.957H66.783v-33.391h33.391V422.957z M445.217,422.957
                          h-33.391v-33.391h33.391V422.957z M478.609,356.174c-14.401,0-412.865,0-445.217,0v-33.391h445.217V356.174z M478.609,289.391
                          H33.391v-16.696c0-9.206,7.49-16.696,16.696-16.696c12.832,0,401.17,0,411.826,0c9.206,0,16.696,7.49,16.696,16.696V289.391z"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <span class="property__amenity-value">{{ v.bedroom }}</span>
                  <span class="property__amenity-label">اتاق</span>
                </div>

                <div class="property__amenity">
                  <div class="property__amenity-icon">
                    <svg
                      v-if="v.total_floor != '1'"
                      fill="#000000"
                      height="25px"
                      width="25px"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 375.795 375.795"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M364.053,324.635V61.498H257.919V35.136H117.877v26.361H11.743v263.138H0v16.023h11.743h149.379h53.552h149.379h11.742
                      v-16.023H364.053z M145.099,324.635H27.767V77.521h117.332V324.635z M214.674,324.635h-53.552v-27.787h53.552V324.635z
                       M214.674,66.494h-18.415v25.492h18.415v15.622h-18.415V133.1h18.415v15.625h-18.415v25.491h18.415v15.623h-18.415v25.492h18.415
                      v15.624h-18.415v25.489h18.415v25.382h-53.552v-25.382h18.414v-25.489h-18.414v-15.624h18.414v-25.492h-18.414v-15.623h18.414
                      v-25.491h-18.414V133.1h18.414v-25.492h-18.414V91.986h18.414V66.494h-18.414v-4.996h-28.224v-11.34h109.999v11.34h-28.224V66.494z
                       M348.029,324.635H230.697V77.521h117.332V324.635z"
                        />
                        <rect
                          x="246.238"
                          y="94.947"
                          width="34.207"
                          height="27.19"
                        />
                        <rect
                          x="298.282"
                          y="94.947"
                          width="34.207"
                          height="27.19"
                        />
                        <rect
                          x="246.238"
                          y="138.802"
                          width="34.207"
                          height="27.189"
                        />
                        <rect
                          x="298.282"
                          y="138.802"
                          width="34.207"
                          height="27.189"
                        />
                        <rect
                          x="246.238"
                          y="182.658"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="298.282"
                          y="182.658"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="246.238"
                          y="226.515"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="298.282"
                          y="226.515"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="246.238"
                          y="270.371"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="298.282"
                          y="270.371"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="43.308"
                          y="94.947"
                          width="34.207"
                          height="27.19"
                        />
                        <rect
                          x="95.351"
                          y="94.947"
                          width="34.207"
                          height="27.19"
                        />
                        <rect
                          x="43.308"
                          y="138.802"
                          width="34.207"
                          height="27.189"
                        />
                        <rect
                          x="95.351"
                          y="138.802"
                          width="34.207"
                          height="27.189"
                        />
                        <rect
                          x="43.308"
                          y="182.658"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="95.351"
                          y="182.658"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="43.308"
                          y="226.515"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="95.351"
                          y="226.515"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="43.308"
                          y="270.371"
                          width="34.207"
                          height="27.191"
                        />
                        <rect
                          x="95.351"
                          y="270.371"
                          width="34.207"
                          height="27.191"
                        />
                      </g>
                    </svg>

                    <svg
                      v-if="v.total_floor == '1'"
                      fill="#000000"
                      height="25px"
                      width="25px"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 486.196 486.196"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M481.708,220.456l-228.8-204.6c-0.4-0.4-0.8-0.7-1.3-1c-5-4.8-13-5-18.3-0.3l-228.8,204.6c-5.6,5-6,13.5-1.1,19.1
                        c2.7,3,6.4,4.5,10.1,4.5c3.2,0,6.4-1.1,9-3.4l41.2-36.9v7.2v106.8v124.6c0,18.7,15.2,34,34,34c0.3,0,0.5,0,0.8,0s0.5,0,0.8,0h70.6
                        c17.6,0,31.9-14.3,31.9-31.9v-121.3c0-2.7,2.2-4.9,4.9-4.9h72.9c2.7,0,4.9,2.2,4.9,4.9v121.3c0,17.6,14.3,31.9,31.9,31.9h72.2
                        c19,0,34-18.7,34-42.6v-111.2v-34v-83.5l41.2,36.9c2.6,2.3,5.8,3.4,9,3.4c3.7,0,7.4-1.5,10.1-4.5
                        C487.708,233.956,487.208,225.456,481.708,220.456z M395.508,287.156v34v111.1c0,9.7-4.8,15.6-7,15.6h-72.2c-2.7,0-4.9-2.2-4.9-4.9
                        v-121.1c0-17.6-14.3-31.9-31.9-31.9h-72.9c-17.6,0-31.9,14.3-31.9,31.9v121.3c0,2.7-2.2,4.9-4.9,4.9h-70.6c-0.3,0-0.5,0-0.8,0
                        s-0.5,0-0.8,0c-3.8,0-7-3.1-7-7v-124.7v-106.8v-31.3l151.8-135.6l153.1,136.9L395.508,287.156L395.508,287.156z"
                        />
                      </g>
                    </svg>
                  </div>
                  <span class="property__amenity-value">{{
                    v.total_floor
                  }}</span>
                  <span
                    v-if="v.total_floor != '1'"
                    class="property__amenity-label"
                    >طبقه</span
                  >
                  <span
                    v-if="v.total_floor == '1'"
                    class="property__amenity-label"
                    >شخصی</span
                  >
                </div>

                <div class="property__amenity">
                  <div class="property__amenity-icon">
                    <svg
                      width="25px"
                      height="25px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 22L2 22"
                        stroke="#1C274C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M3 22.0001V11.3472C3 10.4903 3.36644 9.67432 4.00691 9.10502L10.0069 3.77169C11.1436 2.76133 12.8564 2.76133 13.9931 3.77169L19.9931 9.10502C20.6336 9.67432 21 10.4903 21 11.3472V22.0001"
                        stroke="#1C274C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10 9H14"
                        stroke="#1C274C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M9 15.5H15"
                        stroke="#1C274C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M9 18.5H15"
                        stroke="#1C274C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M18 22V16C18 14.1144 18 13.1716 17.4142 12.5858C16.8284 12 15.8856 12 14 12H10C8.11438 12 7.17157 12 6.58579 12.5858C6 13.1716 6 14.1144 6 16V22"
                        stroke="#1C274C"
                        stroke-width="1.5"
                      />
                    </svg>
                  </div>
                  <span class="property__amenity-value">{{ v.parking }}</span>
                  <span class="property__amenity-label">پارکینگ</span>
                </div>

                <div class="property__amenity">
                  <div class="property__amenity-icon">
                    <svg
                      fill="#000000"
                      height="25px"
                      width="25px"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 491.541 491.541"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M350.373,116.048H24.445C10.942,116.048,0,126.988,0,140.492V466.42c0,13.503,10.942,24.445,24.445,24.445h325.928
                        c13.503,0,24.444-10.942,24.444-24.445V140.492C374.817,126.988,363.876,116.048,350.373,116.048z M325.928,441.975H48.889V164.936
                        h277.039V441.975z"
                        />
                        <path
                          d="M486.695,411.913h-26.513V126.63h26.513c1.958,0,3.724-1.178,4.472-2.991c0.756-1.814,0.342-3.892-1.05-5.283
                        l-42.802-42.802c-1.894-1.894-4.965-1.894-6.858,0l-42.803,42.802c-1.392,1.392-1.806,3.469-1.05,5.283
                        c0.749,1.813,2.515,2.991,4.473,2.991h26.513v285.283h-26.513c-1.958,0-3.724,1.177-4.473,2.991
                        c-0.755,1.815-0.342,3.893,1.05,5.285l42.803,42.802c1.893,1.894,4.965,1.894,6.858,0l42.802-42.802
                        c1.393-1.392,1.807-3.469,1.05-5.285C490.419,413.09,488.654,411.913,486.695,411.913z"
                        />
                        <path
                          d="M70.676,94.563c1.392,1.392,3.469,1.806,5.284,1.05c1.814-0.747,2.992-2.514,2.992-4.472V64.628h285.283v26.513
                        c0,1.958,1.177,3.725,2.991,4.472c1.814,0.756,3.891,0.342,5.284-1.05l42.802-42.802c1.894-1.895,1.894-4.967,0-6.86L372.51,2.1
                        c-1.393-1.393-3.469-1.807-5.284-1.051c-1.814,0.748-2.991,2.514-2.991,4.472v26.515H78.952V5.521c0-1.957-1.177-3.724-2.992-4.472
                        c-1.814-0.756-3.892-0.342-5.284,1.051L27.875,44.901c-1.894,1.893-1.894,4.965,0,6.86L70.676,94.563z"
                        />
                      </g>
                    </svg>
                  </div>
                  <span class="property__amenity-value">{{
                    v.building_area
                  }}</span>
                  <span class="property__amenity-label">مترمربع</span>
                </div>
              </footer>
            </article>
          </a>
        </div>
      </div>
      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div ref="loadMoreTrigger" class="trigger"></div>
    </div> -->

    <!-- <div
      v-if="data_list.length > 0 && loadmore && !isLoading"
      class="apartmentsLoadMoreDataButton"
    >
      <button
        class="loadButton"
        @click="load_data()"
        :disabled="loadmore_loading"
      >
        <span v-if="!loadmore_loading">نمایش بیشتر</span>
        <span v-else class="loader"></span>
      </button>
    </div> -->

    <div
      v-if="data_list.length == 0 && !isLoading"
      class="justify-center align-center mt-4"
      style="text-align: center; height: 90%"
    >
      <img
        :src="publicPath + 'img/notfound.png'"
        alt="Alt text"
        width="320"
        height="280"
      />
      <div class="noResultContent">آگهی ذخیره‌ای نکرده‌اید!</div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
// import { useRouter } from "vue-router/dist/vue-router";
import { Skeletor } from "vue-skeletor";

export default {
  name: "BookmarkPage",
  components: { Skeletor },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      data_list: [],
      fillter: {
        user_id: 0,
        page: 1,
        per_page: 12,
      },
    };
  },
  mounted() {
    this.load_data("first");
    window.addEventListener("scroll", this.handleWindowScroll);
    // nextTick(() => {

    //   const observer = new IntersectionObserver(
    //     ([entry]) => {
    //       if (entry.isIntersecting) {
    //         this.load_data();
    //       }
    //     },
    //     { threshold: 1.0 }
    //   );

    //   if (this.$refs.loadMoreTrigger) {
    //     observer.observe(this.$refs.loadMoreTrigger);
    //   }
    // });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
  methods: {
    showPost(post, index) {
      localStorage.removeItem("post_detail");
      this.$store.commit("post_detail_set", this.data_list[index]);
      this.$router.push(`/details/${post.id}`);
    },
    handleImageError(event) {
      event.target.src = "../assets/img/noimage.jpg";
    },
    save_favorit(post_id) {
      this.helperGet(
        "save-favorite?post_id=" +
          post_id +
          "&user_id=" +
          this.$store.state.auth.uid
      ).then((r) => {
        if (r.data.result == 1) this.load_data("first");
      });
      // axios
      //   .get(
      //     store.getters.baseUrl +
      //       "/save-favorite?post_id=" +
      //       post_id +
      //       "&user_id=" +
      //       store.state.auth.uid,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: "Bearer " + store.getters.appToken,
      //       },
      //     }
      //   )
      //   .then((r) => {
      //     if (r.data.result == 1) this.load_data("first");
      //   });
    },
    handleWindowScroll() {
      let windowSize = window.innerWidth;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      if (windowSize > 1000) {
        if (scrollTop + windowHeight + 686.6 >= fullHeight) {
          if (this.loadmore && !this.loadmore_loading) {
            this.load_data();
          }
        }
      } else {
        if (scrollTop + windowHeight + 100 >= fullHeight) {
          if (this.loadmore && !this.loadmore_loading) {
            this.load_data();
          }
        }
      }
    },
    load_data(param) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;

      if (param === "first") {
        this.isLoading = true;
        this.data_list = [];
        this.fillter.page = 1;
      }

      this.fillter.user_id = this.$store.state.auth.uid;

      this.helperPost("favorite-list", this.fillter).then((r) => {
        console.log(r);
        if (r.data.result == "0") {
          this.data_list = [];
          if (param !== "first") {
            this.fillter.page -= 1;
          }
        } else {
          this.data_list = this.data_list.concat(r.data.list.list);
          if (r.data.list.total_page === this.fillter.page) {
            this.loadmore = false;
          }
        }

        this.isLoading = false;
        this.loadmore_loading = false;
      });
      // axios
      //   .post(store.getters.baseUrl + "/favorite-list", this.fillter, {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: "Bearer " + store.getters.appToken,
      //     },
      //   })
      //   .then((r) => {
      //     if (r.data.result === 0) {
      //       this.data_list = [];
      //       if (param !== "first") {
      //         this.fillter.page -= 1;
      //       }
      //     } else {
      //       this.data_list = this.data_list.concat(r.data.list.list);
      //       if (r.data.list.total_page === this.fillter.page) {
      //         this.loadmore = false;
      //       }
      //     }

      //     this.isLoading = false;
      //     this.loadmore_loading = false;
      //   });
    },
  },
};
</script>

<!-- <script setup>
import { nextTick, onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";
import { Skeletor } from "vue-skeletor";
import { useRouter } from "vue-router/dist/vue-router";
// import InfiniteLoading from "vue-infinite-loading";

const publicPath = ref(process.env.VUE_APP_PUBLIC_PATH);
const isLoading = ref(true);
const loadmore = ref(false);
const loadmore_loading = ref(false);
const router = useRouter(); // Get the current route object

const showPost = (index) => {
  localStorage.removeItem("post_detail");
  store.commit("post_detail_set", data_list.value[index]);
  router.push({ path: "/details" });
};
const loadMoreTrigger = ref(null);

const fillter = ref({
  user_id: 0,
  page: 1,
  per_page: 12,
});
onMounted(async () => {
  await nextTick();
  load_data("first");
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        load_data();
      }
    },
    { threshold: 1.0 }
  );
  if (loadMoreTrigger.value) {
    observer.observe(loadMoreTrigger.value);
  }
});
const handleImageError = (event) => {
  event.target.src = "../assets/img/noimage.jpg";
};
const save_favorit = (post_id) => {
  axios
    .get(
      store.getters.baseUrl +
        "/save-favorite?post_id=" +
        post_id +
        "&user_id=" +
        store.state.auth.uid,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + store.getters.appToken,
        },
      }
    )
    .then((r) => {
      if (r.data.result == 1) load_data("first");
    });
};

const data_list = ref([]);

const load_data = (param) => {
  loadmore.value = true;
  loadmore_loading.value = true;
  fillter.value.page += 1;
  if (param == "first") {
    isLoading.value = true;
    data_list.value = [];
    fillter.value.page = 1;
  }
  fillter.value.user_id = store.state.auth.uid;
  axios
    .post(store.getters.baseUrl + "/favorite-list", fillter.value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + store.getters.appToken,
      },
    })
    .then((r) => {
      if (r.data.result == 0) {
        data_list.value = [];
        if (param != "first") {
          fillter.value.page -= 1;
        }
      } else {
        data_list.value = data_list.value.concat(r.data.list.list);
        console.log("bookmarkLisT", r.data.list);
        if (r.data.list.total_page == fillter.value.page) {
          loadmore.value = false;
        }
      }
      isLoading.value = false;
      loadmore_loading.value = false;

      console.log(" data_list.value", data_list.value);
    });
};
</script> -->

<style lang="scss" scoped>
.ShowTabToUserCustomer {
  width: 100% !important;
}

.topNav__searchbar_wrapper {
  width: 100% !important;
}

.filterbutton_wrapper {
  position: absolute;
  left: 20px;
  top: 7px;
}
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.classShowApartmentSow {
  position: relative;
  margin-top: 0 !important;
  margin-bottom: 20px !important;
}

.deleteIcon {
  position: absolute;
  top: 4%;
  left: 4%;
  width: 32px;
  aspect-ratio: 1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    font-size: 1.25rem;
    color: #0096c7;
  }
}

.dark {
  .categoryTitleWrapper {
    .gardeshgariTitle {
      color: #fff !important;
    }
  }
}

.categoryTitleWrapper {
  width: 100%;
  text-align: center;
  margin-top: -16px;
  margin-bottom: 24px;

  .gardeshgariTitle {
    width: 100% !important;

    &::after,
    &::before {
      width: 90px !important;
    }
  }
}
.noResultContent {
  text-align: center;
  font-size: 0.95rem;
}

@media (min-width: 700px) {
  .categoryTitleWrapper {
    display: none;
  }
}
</style>
